import { ml } from '@/utils/translate_lngs';
import { data_ids, quality_ids, temp_ids, quality_temp_other_ids, all_data_ids } from '@/constant/data_ids';
import _ from 'lodash';
import moment from 'moment';

const precision = {
  temp: 1,
  CYCLE_TIME: 2,
  CLAMP_CLOSE_TIME: 2,
  INJECT_TIME: 2,
  TURN_TIME: 2,
  CHARGE_TIME: 2,
  CLAMP_OPEN_TIME: 2,
  INJECT_BACK_TIME: 2,
  EJECT_TIME: 2,
  CLAMP_OPEN_POSITION: 1,
  INJECT_START_POSITION: 1,
  INJECT_END_POSITION: 1,
  TURN_POSITION: 2,
  TURN_PRESSURE: 2,
  INJECT_MAX_PRESSURE: 2,
  CHARGE_MAX_PRESSURE: 2,
  INJECT_TIME_B: 2,
  TURN_TIME_B: 2,
  CHARGE_TIME_B: 2,
  INJECT_BACK_TIME_B: 2,
  EJECT_TIME_B: 2,
  INJECT_START_POSITION_B: 1,
  INJECT_END_POSITION_B: 1,
  TURN_POSITION_B: 2,
  TURN_PRESSURE_B: 2,
  INJECT_MAX_PRESSURE_B: 2,
  CHARGE_MAX_PRESSURE_B: 2,
};

function normalDistributionFunc(x, u, a) {
  return (1 / (Math.sqrt(2 * Math.PI) * a)) * Math.exp((-1 * ((x - u) * (x - u))) / (2 * a * a));
}

const radomFunc = function (min, max, count) {
  let data = [];
  for (let i = 0; i < count; i++) {
    data.push(Math.random() * (max - min) + min);
  }

  return data;
};

const countScatterData = function (min, max, groupCount, scatterData) {
  const data = JSON.parse(JSON.stringify(scatterData));
  data.sort(function (a, b) {
    return a - b;
  });
  const classWidth = (max - min) / groupCount;
  const countResult = [];
  let j = 0;
  for (let i = 0; i < groupCount; i++) {
    countResult[i] = {
      value: 0,
      name: parseFloat((classWidth * (i + 1)).toFixed(3)),
    };
    for (; j < data.length; j++) {
      if (data[j] - min < countResult[i].name) {
        countResult[i].value++;
      } else break;
    }
  }
  return countResult;
};

//模糊查询过滤
const filterData = (list, queryParams) => {
  Object.keys(queryParams).forEach(key => {
    let list_ = [];
    list.forEach(obj => {
      if (typeof queryParams[key] === 'string') {
        if (obj[key] === null || obj[key] === undefined) {
          obj[key] = '';
        }
        if (obj[key].toString().toUpperCase().indexOf(queryParams[key].toUpperCase()) !== -1) {
          list_.push(obj);
        }
      } else if (!isNaN(queryParams[key]) && typeof queryParams[key] === 'number') {
        if (obj[key] === queryParams[key]) {
          list_.push(obj);
        }
      } else if (Array.isArray(queryParams[key])) {
        if (queryParams[key].length !== 0) {
          if (queryParams[key].indexOf(obj[key]) !== -1) {
            list_.push(obj);
          }
        } else {
          list_.push(obj);
        }
      }
    });
    list = [...list_];
  });
  return list;
};

//字母数字*-_校验函数
const matchFun = (str, len) => {
  let reg = len ? new RegExp(`^[a-zA-Z0-9*-_]{1,${len}}$`, 'g') : /^[a-zA-Z0-9*-_]{1,}$/g;
  if (!len) {
    if (str.match(reg)) {
      return '';
    } else {
      return ml(`MUST_BE_NUMBERS_LETTERS`);
    }
  } else {
    if (str.match(reg) && str.length <= len) {
      return '';
    } else {
      return `${ml('MUST_BE_NUMBERS_LETTERS_LESS_THAN')}${len}`;
    }
  }
};

//用户名密码校验
const matchUserAndPsw = (str, len, types, special) => {
  const type_map = {
    upper_case: 'A-Z',
    lower_case: 'a-z',
    number: '0-9',
  };
  let reg_str = '';
  if (types) {
    types.forEach(type => {
      reg_str += type_map[type];
    });
  }
  if (special) {
    reg_str += special;
  }
  let reg = len ? new RegExp(`^[${reg_str}]{1,${len}}$`, 'g') : /^[${reg_str}]{1,}$/g;
  if (!len) {
    if (str.match(reg)) {
      return '';
    } else {
      return ml(`NON_CONFORMITY_RULE`);
    }
  } else {
    if (str.match(reg) && str.length <= len) {
      return '';
    } else {
      return `${ml('MUST_BE__CONFORMITY_RULE_LESS_THAN')}${len}`;
    }
  }
};

/**
 * 计算上限、下限、平均值、最大值、最小值等数据
 * @param numbers 数据
 */
const calcNumber = (numbers, type) => {
  let max_ref = 0;
  let min_ref = 0;
  let sum = 0;
  let spacing = 0.01;
  let max = numbers[0] ? parseFloat(numbers[0]) : 0;
  let min = numbers[0] ? parseFloat(numbers[0]) : 0;
  numbers.forEach(number => {
    if (max < parseFloat(number)) {
      max = parseFloat(number);
    }
    if (min > parseFloat(number)) {
      min = parseFloat(number);
    }
    sum += parseFloat(number);
  });
  //平均值
  let avg = numbers.length === 0 ? 0 : sum / numbers.length;
  //标准差
  let sum_ = 0;
  numbers.forEach(number => {
    sum_ += Math.pow(parseFloat(number) - avg, 2);
  });
  let sigma = Math.sqrt(numbers.length === 0 ? 0 : sum_ / numbers.length);
  //上限和下限
  max_ref = avg + 3 * sigma;
  min_ref = avg - 3 * sigma;
  spacing = (max_ref - min_ref) / 10 + 0.01;
  let statistics = [];
  let min_ = min;
  let i = 0;
  while (i < 10) {
    statistics.push({
      min: min_ + i * spacing,
      max: min_ + (i + 1) * spacing,
      actual_count: 0,
    });
    i++;
  }
  statistics = statistics.map(statistic => {
    numbers.forEach(number => {
      if (parseFloat(number) > statistic.min && parseFloat(number) <= statistic.max) {
        statistic.actual_count++;
      }
    });
    return statistic;
  });

  return {
    max: parseFloat(type && precision[type] ? max.toFixed(precision[type]) : max.toFixed(3)),
    min: parseFloat(type && precision[type] ? min.toFixed(precision[type]) : min.toFixed(3)),
    miu: parseFloat(type && precision[type] ? avg.toFixed(precision[type]) : avg.toFixed(3)),
    sigma: parseFloat(type && precision[type] ? sigma.toFixed(precision[type]) : sigma.toFixed(3)),
    max_ref: parseFloat(
      type && precision[type] ? max_ref.toFixed(precision[type]) : max_ref.toFixed(3)
    ),
    min_ref: parseFloat(
      type && precision[type] ? min_ref.toFixed(precision[type]) : min_ref.toFixed(3)
    ),
    spacing: spacing,
    statistics: statistics,
  };
};

/**
 * 计算上限、下限、平均值、最大值、最小值、正态分布等数据
 * @param numbers 数据
 * @param count 组数 默认10
 */
const calcUpperAndLower = (numbers, count) => {
  count = count ? count : 10;
  let sum = 0;
  numbers.forEach(number => {
    sum += number;
  });
  //平均值
  let avg = numbers.length === 0 ? 0 : sum / numbers.length;
  //标准差
  let sum_ = 0;
  numbers.forEach(number => {
    sum_ += Math.pow(parseFloat(number) - avg, 2);
  });
  let stdDeviation = Math.sqrt(numbers.length === 0 ? 0 : sum_ / numbers.length);
  //上限和下限
  let upper = avg + 3 * stdDeviation;
  let lower = avg - 3 * stdDeviation < 0 ? 0 : avg - 3 * stdDeviation;
  //区间
  let region = upper - lower;
  //组距
  let gdist = count === 1 ? 0 : parseFloat((region / count).toFixed(3));
  gdist = gdist ? gdist : 1;
  //组坐标
  let distCategories = [];
  let ele = parseFloat(lower.toFixed(2));
  //频数
  let frequency = [];
  //正态分布
  let dist = [];
  for (let i = 0; i < count + 1; i++) {
    distCategories.push(parseFloat(ele.toFixed(3)));
    frequency.push({
      y: calcCount(numbers, ele, ele + gdist),
      name: `${ele.toFixed(3)}~${(ele + gdist).toFixed(3)}`,
    });
    if (ele + gdist > upper) {
      break;
    }
    ele += gdist;
  }

  let maxFx = 0;

  for (let i = 0; i < distCategories.length; i++) {
    let normdist =
      stdDeviation === 0 ? 0 : normalDistributionfun(distCategories[i], avg, stdDeviation);
    if (maxFx < normdist) {
      maxFx = normdist;
    }
    dist.push(parseFloat(normdist.toFixed(3)));
  }

  return {
    sum: sum,
    avg: avg.toFixed(3),
    stdDeviation: stdDeviation,
    upper: upper.toFixed(3),
    lower: lower.toFixed(3),
    distCategories: distCategories,
    dist: dist,
    frequency: frequency,
    maxFx: maxFx,
  };
};

const calcCount = (numbers, x1, x2) => {
  let result = 0;
  if (x1 && !x2) {
    for (let i = 0; i < numbers.length; i++) {
      if (x1 >= numbers[i]) {
        result++;
      }
    }
  } else {
    for (let i = 0; i < numbers.length; i++) {
      if (numbers[i] >= x1 && numbers[i] < x2) {
        result++;
      }
    }
  }
  return result;
};

/**
 * 正态分布函数
 * @param x 数据
 * @param mean 平均数
 * @param stdev 标准差
 */
const normalDistributionfun = (x, mean, stdev) => {
  return (
    (1 / (Math.sqrt(2 * Math.PI) * stdev)) *
    Math.exp((-1 * ((x - mean) * (x - mean))) / (2 * stdev * stdev))
  );
};

const pointFormatter = (data, upper, lower) => {
  let list = [];
  data.forEach(y => {
    if (y < lower || y > upper) {
      let obj = {};
      obj.y = y;
      obj.color = 'red';
      list.push(obj);
    } else {
      list.push(y);
    }
  });
  return list;
};

const typeConvert = (value, type) => {
  let v_;
  if (type === 'string') {
    v_ = value.toString();
  }
  switch (type) {
    case 'string':
      v_ = value.toString();
      break;
    case 'int':
      v_ = value ? parseInt(value) : 0;
      break;
    case 'float':
      v_ = value ? parseFloat(value) : 0;
      break;
    default:
      v_ = value;
      break;
  }
  return v_;
};

/**
 * 处理合并行数量
 * @param list 数据
 * @param cols 需要合并的列
 * @param col 主要列
 */
const convertRowSpan = (list, cols, col) => {
  let col_span = {};
  list.forEach(d => {
    Object.keys(d).forEach(key => {
      if (cols.indexOf(key) !== -1) {
        if (!col_span[key]) {
          col_span[key] = {};
          if (d[key] !== '' && d[key] !== null && d[key] !== undefined) {
            col_span[key][d[key]] = {
              spanned: false,
              rows: 1,
            };
          }
        } else {
          if (d[key] !== '' && d[key] !== null && d[key] !== undefined) {
            if (!col_span[key][d[key]]) {
              col_span[key][d[key]] = {
                spanned: false,
                rows: 1,
              };
            } else {
              col_span[key][d[key]].rows += 1;
            }
          }
        }
      }
    });
  });
  let init_row_span = {};
  cols.forEach(c => {
    init_row_span[c] = 1;
  });

  let list_ = list.map(d => {
    let row_span = { ...init_row_span };
    Object.keys(d).forEach(key => {
      if (col_span[key] && col_span[key][d[key]]) {
        if (col_span[key][d[key]].spanned) {
          row_span[key] = 0;
        } else {
          row_span[key] = col_span[key][d[key]].rows;
          col_span[key][d[key]].spanned = true;
        }
      }
    });
    //有主要列时，其他列合并行数与主要列保持一致
    if (col) {
      Object.keys(row_span).forEach(key => {
        if (key !== col) {
          row_span[key] = row_span[col];
        }
      });
    }
    d._rowSpan = { ...row_span };
    return d;
  });
  return list_;
};

const getBool = (dataValue, operate, value) => {
  if (operate === 'equal') {
    return _.isEqual(dataValue.toString().toLowerCase(), value.toString().toLowerCase());
  } else if (operate === 'unequal') {
    return dataValue.toString().toLowerCase() !== value.toString().toLowerCase();
  } else if (operate === 'greater') {
    return dataValue > value;
  } else if (operate === 'less') {
    return dataValue < value;
  } else if (operate === 'start_by') {
    return _.startsWith(dataValue.toString().toLowerCase(), value.toString().toLowerCase());
  } else if (operate === 'end_by') {
    return _.endsWith(dataValue.toString().toLowerCase(), value.toString().toLowerCase());
  } else if (operate === 'contains') {
    return _.indexOf(dataValue.toString().toLowerCase(), value.toString().toLowerCase()) !== -1;
  } else if (operate === 'exclude') {
    return _.indexOf(dataValue.toString().toLowerCase(), value.toString().toLowerCase()) === -1;
  } else {
    return true;
  }
};

const operateFilter = (text_filter, str) => {
  let bool = true;
  let conditions = text_filter.conditions;
  let operate = text_filter.operate;
  let con_bool1 = true;
  let operate1 = conditions[0].operate;
  let value1 = conditions[0].value;

  let operate2 = conditions[1] ? conditions[1].operate : '';
  let value2 = conditions[1] ? conditions[1].value : '';

  con_bool1 = getBool(str, operate1, value1);

  let con_bool2 = conditions[1] ? getBool(str, operate2, value2) : true;
  if (operate === 'and') {
    bool = con_bool1 & con_bool2;
  } else {
    bool = conditions[1] ? con_bool1 || con_bool2 : con_bool1;
  }
  return bool;
};

const transform = (list, columns) => {
  let lst = [];
  list.forEach(d => {
    let obj = JSON.parse(JSON.stringify(d));
    columns.forEach(column => {
      obj[column.field] = column.formatter ? column.formatter(obj) : obj[column.field];
    });
    lst.push(obj);
  });
  return lst;
};

//筛选
const filterColumnData = (list, filter, columns, idField) => {
  let list_ = JSON.parse(JSON.stringify(list));
  list_ = transform(list_, columns);
  if (filter.length !== 0) {
    let iteratees = [];
    let orders = [];
    filter.forEach(filter_ => {
      if (filter_.sort) {
        iteratees.push(item => {
          return item[filter_.field];
        });
        orders.push(filter_.sort);
      }
    });
    //文本过滤
    list_ = _.filter(list_, d => {
      let bool = true;
      filter.forEach(filter_ => {
        let text_filter = filter_.text_filter;
        if (text_filter) {
          let bool_ = operateFilter(text_filter, d[filter_.field]);
          if (!bool_) {
            bool = false;
          }
        }
      });
      return bool;
    });

    //选择过滤
    list_ = _.filter(list_, d => {
      let bool = true;
      filter.forEach(filter_ => {
        if (
          filter_.selected &&
          (d[filter_.field] === undefined ||
            _.indexOf(filter_.selected, d[filter_.field].toString()) === -1)
        ) {
          bool = false;
        }
      });
      return bool;
    });
    //排序
    list_ = _.orderBy(list_, iteratees, orders);
  }

  let lst = [];

  list_.forEach(l2 => {
    list.forEach(l1 => {
      if (l1[idField] && l2[idField] && l1[idField] === l2[idField]) {
        lst.push(l1);
      }
    });
  });

  return idField ? lst : list_;
};

//温度资料处理
const transformTempData = (obj, pageIndex, pageSize) => {
  let list = [];
  let dataList = [];
  let fields = [];
  let columns_ = [];
  let actual_value = {};
  let set_value = {};
  let shot_count_ = [];
  let catch_time_ = [];
  let keys_ =
    pageIndex && pageSize
      ? Object.keys(obj).slice(pageSize * (pageIndex - 1), pageSize * pageIndex)
      : Object.keys(obj);
  let total = Object.keys(obj).length;
  keys_.forEach(shotCount => {
    shot_count_.push(shotCount);
    let dataObj = { shot_count: shotCount, catch_time: obj[shotCount].catch_time };
    catch_time_.push(obj[shotCount].catch_time);
    temp_ids.forEach(id => {
      if (fields.indexOf(data_ids[id]) === -1) {
        fields.push(data_ids[id]);
      }
      dataObj[data_ids[id]] = obj[shotCount][id] ? parseFloat(obj[shotCount][id]) : 0;

      let temp = data_ids[id].replace(/ACTUAL_TEMP|SET_TEMP/g, '');
      //实际温度
      if (data_ids[id].indexOf('ACTUAL_TEMP') !== -1) {
        if (!actual_value[temp]) {
          actual_value[temp] = [];
        }
        actual_value[temp].push(obj[shotCount][id] ? obj[shotCount][id] : 0);
      }
      //设定温度
      if (data_ids[id].indexOf('SET_TEMP') !== -1) {
        if (!set_value[temp]) {
          set_value[temp] = [];
        }
        set_value[temp].push(obj[shotCount][id] ? obj[shotCount][id] : 0);
      }
      //驱动器、马达
      if (
        data_ids[id].indexOf('AUSTON_ACTUALDATA_POWERTEMP') !== -1 ||
        data_ids[id].indexOf('MOTORTEMP') !== -1
      ) {
        if (!actual_value[temp]) {
          actual_value[temp] = [];
        }
        actual_value[temp].push(obj[shotCount][id] ? obj[shotCount][id] : 0);
      }
    });

    dataList.push(dataObj);
  });

  fields.forEach(field => {
    columns_.push({
      field: field,
      title: `${field.indexOf('ACTUAL_TEMP') !== -1
        ? `${ml(field.replace(/\d/g, ''))}${field.replace(/ACTUAL_TEMP|SET_TEMP/g, '')}`
        : ml(field)
        }`,
      halign: 'center',
      align: 'right',
      width: 100,
      render: ({ row }) => {
        return row[field] !== undefined ? row[field].toFixed(1) : '';
      },
    });
  });
  Object.keys(actual_value).forEach(key => {
    let list_ = actual_value[key];
    let record_ = [];
    list_ = list_.map((d, index) => {
      record_.push({
        shot_count: shot_count_[index],
        time: catch_time_[index],
        set_value: [set_value[key] ? (set_value[key][index] ? set_value[key][index] : 0) : 0],
        actual_value: [d ? d : 0],
      });
      return d ? d : 0;
    });
    let obj_ = calcNumber(list_, 'temp');
    let obj = {
      ...obj_,
      name: `${/^[0-9]+$/.test(key) ? `TEMPERATURE${key}` : ml(key)}`,
      unit: '℃',
      record: record_,
    };
    list.push(obj);
  });

  return {
    spacing_count: 10,
    data: list,
    columns: columns_,
    dataList: dataList,
    total: total,
  };
};

//品质资料处理
const transformQualityData = (obj, pageIndex, pageSize) => {
  let list = [];
  let dataList = [];
  let fields = [];
  let columns_ = [];
  let actual_value = {};
  let shot_count_ = [];
  let catch_time_ = [];
  let keys_ =
    pageIndex && pageSize
      ? Object.keys(obj).slice(pageSize * (pageIndex - 1), pageSize * pageIndex)
      : Object.keys(obj);
  let total = Object.keys(obj).length;
  quality_ids.forEach(id => {
    if (fields.indexOf(data_ids[id]) === -1) {
      fields.push(data_ids[id]);
    }
  });
  keys_.forEach(shotCount => {
    shot_count_.push(shotCount);
    let dataObj = { shot_count: shotCount, catch_time: obj[shotCount].catch_time };
    catch_time_.push(obj[shotCount].catch_time);
    quality_ids.forEach(id => {
      dataObj[data_ids[id]] = obj[shotCount][id];
      if (!actual_value[data_ids[id]]) {
        actual_value[data_ids[id]] = [];
      }
      actual_value[data_ids[id]].push(obj[shotCount][id]);
    });
    dataList.push(dataObj);
  });

  fields.forEach(field => {
    columns_.push({
      field: field,
      title: ml(field),
      halign: 'center',
      align: 'right',
      width: 100,
      render: ({ row }) => {
        return row[field] !== undefined
          ? row[field].toFixed(precision[field] ? precision[field] : 2)
          : '';
      },
    });
  });
  Object.keys(actual_value).forEach(key => {
    let list_ = actual_value[key];
    let record_ = [];
    list_ = list_.map((d, index) => {
      record_.push({
        shot_count: shot_count_[index],
        time: catch_time_[index],
        set_value: null,
        actual_value: [d ? d : 0],
      });
      return d ? d : 0;
    });
    let obj_ = calcNumber(list_, key);
    let obj = { ...obj_, name: key, record: record_ };
    list.push(obj);
  });
  return {
    spacing_count: 10,
    data: list,
    columns: columns_,
    dataList: dataList,
    total: total,
  };
};
//品质质料和温度质料处理
const transformQualityTempData = (obj) => {
  let dataList = [];
  Object.keys(obj).forEach(shotCount => {
    let dataObj = { ...obj[shotCount], mode_shot_count: shotCount };
    quality_temp_other_ids.forEach(id => {
      dataObj[all_data_ids[id]] = obj[shotCount][id] ? obj[shotCount][id] : 0;
    });
    if (dataObj['total_energy'] && dataObj['servo_energy'] && dataObj['elec_energy']) {
      dataObj['server_energy'] = dataObj['total_energy'] - dataObj['servo_energy'] - dataObj['elec_energy']
    }
    dataList.push(dataObj);
  });

  return (dataList.sort((a, b) => b.shot_time - a.shot_time)).sort((a, b) => a.device_sn.localeCompare(b.device_sn));
};
const transformQualityTempDataExport = (obj) => {
  let dataList = [];
  Object.keys(obj).forEach(deviceID => {
    Object.keys(obj[deviceID]).forEach(shotCount => {
      let dataObj = { ...obj[deviceID][shotCount], mode_shot_count: shotCount };
      quality_temp_other_ids.forEach(id => {
        dataObj[all_data_ids[id]] = obj[deviceID][shotCount][id] ? obj[deviceID][shotCount][id] : 0;
      });
      dataList.push(dataObj);
    });
  });
  return (dataList.sort((a, b) => b.shot_time - a.shot_time)).sort((a, b) => a.device_sn.localeCompare(b.device_sn));
};
//时间格式化，时:分'秒''(xxx:xxx'xxx'')
const formatSeconds = value => {
  if (!value) {
    return "0''";
  }
  var secondTime = parseInt(value);
  var minuteTime = 0;
  var hourTime = 0;
  if (secondTime > 60) {
    minuteTime = parseInt(secondTime / 60);
    secondTime = parseInt(secondTime % 60);
    if (minuteTime > 60) {
      hourTime = parseInt(minuteTime / 60);
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  var result = '' + parseInt(secondTime) + "''";
  if (minuteTime > 0) {
    result = '' + parseInt(minuteTime) + "'" + result;
  }
  if (hourTime > 0) {
    result = '' + parseInt(hourTime) + ':' + result;
  }
  return result;
};

//班次判断
const getClassInfo = (class_info, date) => {
  let class_obj = {};
  class_obj.date = date;
  class_obj.class_name = class_info.class_name;
  if (class_info.inter_day === 1) {
    let nt = moment().format('HH:mm');
    if (nt <= class_info.start_time) {
      class_obj.date = moment(new Date(date)).subtract(1, 'days').format('MM-DD');
    }
  } else if (class_info.inter_day === 2) {
    class_obj.date = moment(new Date(date)).subtract(1, 'days').format('MM-DD');
  } else if (class_info.inter_day === 3) {
    class_obj.date = moment(new Date(date)).subtract(1, 'days').format('MM-DD');
  }
  class_obj.start_time = class_info.start_time;
  class_obj.end_time = class_info.end_time;
  return class_obj;
};

export {
  normalDistributionFunc,
  radomFunc,
  countScatterData,
  filterData,
  matchFun,
  calcUpperAndLower,
  normalDistributionfun,
  matchUserAndPsw,
  pointFormatter,
  typeConvert,
  convertRowSpan,
  filterColumnData,
  getBool,
  transform,
  calcNumber,
  transformTempData,
  transformQualityData,
  precision,
  formatSeconds,
  getClassInfo,
  transformQualityTempData,
  transformQualityTempDataExport,
};
